module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\r\n        Filter By\r\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$store.state.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.getBranchWiseRecord
    },
    model: {
      value: (_vm.branchDetails),
      callback: function($$v) {
        _vm.branchDetails = $$v
      },
      expression: "branchDetails"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Latest Orders")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/trialbalance/export/excel?startDate=" + (_vm.filter.startDate) + "&endDate=" + (_vm.filter.endDate))
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export\r\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.rows), function(item) {
    return _c('table', {
      key: item.id,
      staticClass: "table table-striped table-bordered table-hover",
      attrs: {
        "border": "1"
      }
    }, [_c('tbody', {
      staticClass: "thead-light"
    }, [_c('tr', [_c('th', {
      staticClass: "thead-dark",
      attrs: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(item.group))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(_vm.openingAmountGP(item)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm.drAmountGP(item)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "width": "13%"
      }
    }, [_vm._v(_vm._s(_vm.crAmountGP(item)))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "12%"
      }
    }, [_vm._v("0")])]), _vm._v(" "), _vm._l((item.ledgers), function(ledger) {
      return _c('tr', {
        key: ledger.id + 'a'
      }, [_c('td', {
        attrs: {
          "width": "50%"
        }
      }, [_vm._v(_vm._s(ledger.name))]), _vm._v(" "), _c('td', {
        attrs: {
          "width": "12%"
        }
      }, [_vm._v(_vm._s(_vm.openingAmount(ledger)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "color": "green"
        },
        attrs: {
          "width": "13%"
        }
      }, [_vm._v(_vm._s(_vm.drAmount(ledger)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "width": "13%"
        }
      }, [_vm._v(_vm._s(_vm.crAmount(ledger)))]), _vm._v(" "), _c('td', {
        attrs: {
          "width": "12%"
        }
      }, [_vm._v(_vm._s(_vm.closingAmount(ledger)))])])
    })], 2)])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-bordered table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("PARTICULARS")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "12%"
    }
  }, [_vm._v("OPENING")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("DEBIT")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("CREDIT")]), _vm._v(" "), _c('th', {
    attrs: {
      "widthwidth": "12%"
    }
  }, [_vm._v("CLOSING")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72686ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/accounting/TrailBalance.vue
// module id = 892
// module chunks = 0